import {
  GET_PAYMENT_PROFILE,
  GET_PAYMENT_PROFILE_SUCCESS,
  GET_PAYMENT_PROFILE_ERROR,
  GET_PAYMENT_PROFILE_LIST,
  GET_PAYMENT_PROFILE_LIST_SUCCESS,
  GET_PAYMENT_PROFILE_LIST_ERROR,
  SAVE_PAYMENT_PROFILE,
  SAVE_PAYMENT_PROFILE_SUCCESS,
  SAVE_PAYMENT_PROFILE_ERROR,
  GET_MONERIS_CHECKOUT_REQUEST_DATA,
  GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS,
  GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR,
  GET_MONERIS_CHECKOUT_RECEIPT,
  GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS,
  GET_MONERIS_CHECKOUT_RECEIPT_ERROR,
  PAY_USING_CREDIT_CARD,
  PAY_USING_CREDIT_CARD_SUCCESS,
  PAY_USING_CREDIT_CARD_ERROR,
  UPDATE_PAYMENT_METHOD_SELECT_STATE,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR,
  RECORD_PAYMENT,
  RECORD_PAYMENT_SUCCESS,
  RECORD_PAYMENT_ERROR,
  TRASH_PAYMENT_PROFILE,
  TRASH_PAYMENT_PROFILE_SUCCESS,
  TRASH_PAYMENT_PROFILE_ERROR
} from "../actions";

export const getPaymentProfile = (profileId) => ({
  type: GET_PAYMENT_PROFILE,
  payload: { profileId },
});

export const getPaymentProfileSuccess = (paymentProfile) => ({
  type: GET_PAYMENT_PROFILE_SUCCESS,
  payload: paymentProfile,
});

export const getPaymentProfileError = (message) => ({
  type: GET_PAYMENT_PROFILE_ERROR,
  payload: { message },
});

export const getPaymentProfileList = (contactId, activityInfo) => ({
  type: GET_PAYMENT_PROFILE_LIST,
  payload: { contactId, activityInfo },
});

export const getPaymentProfileListSuccess = (paymentProfileList) => ({
  type: GET_PAYMENT_PROFILE_LIST_SUCCESS,
  payload: paymentProfileList,
});

export const getPaymentProfileListError = (message) => ({
  type: GET_PAYMENT_PROFILE_LIST_ERROR,
  payload: { message },
});

export const savePaymentProfile = (paymentProfile) => ({
  type: SAVE_PAYMENT_PROFILE,
  payload: { paymentProfile },
});

export const savePaymentProfileSuccess = (paymentProfile) => ({
  type: SAVE_PAYMENT_PROFILE_SUCCESS,
  payload: paymentProfile,
});

export const savePaymentProfileError = (message) => ({
  type: SAVE_PAYMENT_PROFILE_ERROR,
  payload: { message },
});

export const getMonerisCheckoutRequestData = (paymentRedirectRequest, isMonerisCheckoutAddCard, isMonerisCheckoutEditCard, activityInfo) => ({
  type: GET_MONERIS_CHECKOUT_REQUEST_DATA,
  payload: { paymentRedirectRequest, isMonerisCheckoutAddCard, isMonerisCheckoutEditCard, activityInfo},
});

export const getMonerisCheckoutRequestDataSuccess = (monerisCheckoutTicket) => ({
  type: GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS,
  payload: monerisCheckoutTicket,
});

export const getMonerisCheckoutRequestDataError = (message) => ({
  type: GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR,
  payload: { message },
});

export const getMonerisCheckoutReceipt = (receiptRequestParams, activityInfo) => ({
  type: GET_MONERIS_CHECKOUT_RECEIPT,
  payload: {receiptRequestParams, activityInfo},
});

export const getMonerisCheckoutReceiptSuccess = (monerisCheckoutReceipt) => ({
  type: GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS,
  payload: monerisCheckoutReceipt,
});

export const getMonerisCheckoutReceiptError = (message) => ({
  type: GET_MONERIS_CHECKOUT_RECEIPT_ERROR,
  payload: { message },
});

export const payUsingCreditCard = (orderId, paymentProfileId, paymentMethodId) => ({
  type: PAY_USING_CREDIT_CARD,
  payload: { orderId, paymentProfileId, paymentMethodId },
});

export const payUsingCreditCardSuccess = (paymentSuccessInfo) => ({
  type: PAY_USING_CREDIT_CARD_SUCCESS,
  payload: paymentSuccessInfo,
});

export const payUsingCreditCardError = (message) => ({
  type: PAY_USING_CREDIT_CARD_ERROR,
  payload: { message },
});

export const getMonerisCheckoutPaymentMethods = (activityInfo) => ({
  type: GET_MONERIS_CHECKOUT_PAYMENT_METHODS,
  payload: { activityInfo },
});

export const getMonerisCheckoutPaymentMethodsSuccess = (paymentMethods) => ({
  type: GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS,
  payload: paymentMethods,
});

export const getMonerisCheckoutPaymentMethodsError = (message) => ({
  type: GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR,
  payload: { message },
});

export const recordPayment = (requestData, activityInfo) => ({
  type: RECORD_PAYMENT,
  payload: { requestData, activityInfo },
});

export const recordPaymentSuccess = (recordPaymentInfo) => ({
  type: RECORD_PAYMENT_SUCCESS,
  payload: recordPaymentInfo,
});

export const recordPaymentError = (message) => ({
  type: RECORD_PAYMENT_ERROR,
  payload: { message },
});

export const updatePaymentMethodSelectState = (newState) => {
  return {
    type: UPDATE_PAYMENT_METHOD_SELECT_STATE,
    payload: newState,
  };
};

export const trashPaymentProfile = (paymentProfileId) => ({
  type: TRASH_PAYMENT_PROFILE,
  payload: { paymentProfileId },
});

export const trashPaymentProfileSuccess = () => ({
  type: TRASH_PAYMENT_PROFILE_SUCCESS,
  payload: {},
});

export const trashPaymentProfileError = (message) => ({
  type: TRASH_PAYMENT_PROFILE_ERROR,
  payload: { message },
});